import { render, staticRenderFns } from "./AtendimentoList.vue?vue&type=template&id=2963f7e8&scoped=true"
import script from "./AtendimentoList.vue?vue&type=script&lang=js"
export * from "./AtendimentoList.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoList.vue?vue&type=style&index=0&id=2963f7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2963f7e8",
  null
  
)

export default component.exports